// config 项目中的配置文件
// config.js 项目中公共方法文件
// 缓存
// Cookie 浏览器缓存 大小（不大 单个缓存存储时 存储的数据一旦太长 存储无效） 清除历史记录
// localStorage 本地存储 （大） 清除方式 电脑管家 清存操作
// sessionStorage 会话存储 大小 (localStorage) 清除方式 关闭浏览器当前窗口
// 用户缓存在获取时不能默认一定能获取到
import Cookies from "js-cookie";//
/*
    1.存入的名称 浏览器的缓存是共享
    // 所以我们取名字时候要注意特殊性 
    2.存入的值 存入值必须是基本数据类型 如果存的是引用数据类型（obj Array symbol fn） JSON.Stringify()
    3.存入的时间 （缓存的保质期一般来说是7天 但最终解释权归产品经理所有）
    隐藏面试题（怎么解决Cookie的浏览器跨域）
    1.我们项目使用的node搭建的服务器所以不存在缓存关于
    2.后端在我的电脑上搭建Tomcat服务器我在上面写代码
    3. 后端不帮我 我会在度娘上下载一个Nginx来代理写代码
*/ 
// 存缓存
// Cookie.set(存储的名字,存储的值，存储的天数)
export const SetCookie = (name , Cookie)=>{//缓存的名字 存储的数据值
    Cookies.set(name  , Cookie , {expires:7})
}
// 取缓存 Cookies.get(获取缓存的名字) 返回的当前缓存的值 入参（需要获取的缓存名字）
export const GetCookie = name => Cookies.get(name);

// 删除缓存
// Cookie.remove(需要删除的缓存名字)
export const RemoveCookie  = name =>{
    Cookies.remove(name)
}
// localStorage 本地缓存
// 在情况下使用localStorage 在单个缓存存的数据量太大没法存进cookie时候我们才会使用本地缓存
// 存缓存 （存入的名字 ，存入的数据（不能是引用数据类型））
export const setStore = (name , obj)=>{
    window.localStorage.setItem(name , obj)
}
// 取缓存
export const getStore = name => window.localStorage.getItem(name)
// 删除指定缓存
export const removeStore = name =>{
    window.localStorage.removeItem(name)
}
// 清除用户电脑里面所有的本地缓存 (用户注销 ，退出登录)
export const getClear = ()=>{
    window.localStorage.clear()
}
// sessionStorage 会话缓存 （页面窗口关闭 ）用了Cookie就不用sessionStorage 用了sessionStorage就不用cookie
// 存缓存
export const setSee=(name , obj)=>{
    window.sessionStorage.setItem(name , obj)
}
// 取缓存
export const getSee = name => window.sessionStorage.getItem(name)
// 删除缓存
export const removeSee = name =>{
    window.sessionStorage.removeItem(name)
}
/*
    let Vue= {
        ......
        use:functtion(){
            ....
        }
    }
    export default Vue 

*/ 
// 递归防null resp后端返回数据
export const setnullString = (resp)=>{
  
    // 如果说对象是null就变成{}
    // 如果是"null"就变成""
    if(!resp){
        resp = {}
    }
    // 如果不是null就是对象
    for(let i in resp){
        // {} []
        // 判断循环每一个值是不是对象或者是数组但不是null
        if(resp[i] && typeof(resp[i])== "object"){
            setnullString(resp[i])
        }else{
            // null 基本数据类型
            if(Object.is(resp[i] , null)){
                resp[i]= {}
            }else if(Object.is(resp[i],"null")){
                resp[i]= ""
            }
        }
    }
    return resp
    
}



// WEBPACK FOOTER //
// ./src/config/config.js